<div class="row row-style-card width-66pe" *ngIf="Showarrow">
  <a class="nav-link-hand new-button-counselling font-size-15px" title="Back To Activities" (click)="BackToActivities()"><i class="fas fa-angle-double-left font-size-16px margin-right-4px"></i>Back To Activities</a>
</div>
<div class="card my-profile-form margin-top-20px" *ngIf="ShowTracking">
  <div class="card-header wh-header card-title-schedule-bl padding-top-6px padding-bottom-6px">
    <div class="row margin-top-3px">
      <div class="col-md-3 padding-left-0px">
        Daily Work Book
      </div>
     <div class="col-md-8 padding-right-0px">
       <div class="row">
         <div class=" offset-md-6 col-md-3 col-sm-3 padding-right padding-left-0px">
           <div class="form-group  margin-bottom-5px">
             <div class="row">
               <div (click)="DecrementDate()" class="col-md-1 margin-top-auto margin-bottom-auto padding-left-6px padding-right-19px decrementhover">
                 <a title="Previous" class="nav-link-hand">
                   <i class="fas fa-caret-left margin-top-3px font-size-24px"></i>
                 </a>
               </div>

               <!--<div class=" col-md-2 padding-left-0px col-sm-4 text-align-right padding-right-10px">

    <label for="diaplayName " class="font-size-15px margin-top-5px margin-bottom-0px">Date</label>
  </div>-->

               <div class="col-md-8 col-sm-4 padding-l-0px padding-right-9px">
                 <div class="date-form">
                   <input class="form-control border-top-0 border-left-0 border-right-0 border-bottom-0px border-radius-2px font-size-24px data-color-new" placeholder="From Date" [minDate]="minDate" [maxDate]="maxDate"
                          name="SelectedFromDate" [(ngModel)]="SelectedFromDate" ngbDatepicker #d="ngbDatepicker"
                          (ngModelChange)="dataChanged($event)">

                   <a (click)="d.toggle()" class="nav-link-hand">
                     <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                   </a>

                 </div>



               </div>
               <div (click)="IncrementDate()" class="col-md-1 margin-top-auto margin-bottom-auto padding-left-6px padding-right-19px decrementhover">
                 <a title="Next" class="nav-link-hand">
                   <i class="fas fa-caret-right margin-top-3px font-size-24px"></i>
                 </a>
               </div>
               <div class="col-md-1 padding-left-0px">
                 <a class="nav-link-hand education-navlink data-color-new" title="print" (click)="printactivity()">
                   <span class="badge font-size-16px padding-left-0px padding-top-0px padding-bottom-0px"><i class="fa fa-print"></i></span>
                 </a>
               </div>
             </div>

           </div>
         </div>
         <div class="col-md-3 float-right padding-right-0px">
           <input type="text" class="form-control" placeholder="Search" (input)="criteriaChange($event.target.value)">
         </div>
       </div>
     </div>
    </div>

  </div>
  <div class="card-body padding-top-0px">
    <!--<div class="row margin-bottom-10px margin-top-10">
    <div class="col-md-8 padding-left-30px padding-right-0px">
      <div class="row">
        <div class="col-md-3">
          <input type="text" class="form-control" placeholder="Search" (input)="criteriaChange($event.target.value)">
        
        </div>
       

      </div>
    </div>

  </div>-->
    
    <div class="row">
      <div class="col-md-12">
        <div class="table-component">
          <div class="table-responsive overflow-x">


            <table class="table table-striped margin-left-zero"
                   cols="auto,2*,*,*,*,*,*,*">

              <thead class="">
                <tr>

                  <th class="td-width-103px">
                    Date
                  </th>
                  <!--<th class="text-align-center">Day</th>-->

                  <th class="">
                    Patient Name
                  </th>
                  <th class="">Branch</th>
                  <th class="td-width-103px">Mode</th>
                  <th class="td-width-159px">
                    Status
                  </th>
                  <th class="">Created By</th>
                  <th class="">Assigned To</th>
                  <th class="">
                    Remarks
                  </th>





                  <th class=""></th>





                </tr>
              </thead>

              <tbody class="table-body">
                <tr *ngFor="let l of CurrentCounsellingActivitiesByTimeController">

                  <td class="padding-right-0px td-padding-tb ">
                    <div [ngSwitch]="l.FollowupStatus">
                      <!--<div *ngSwitchCase="''">
        <label class="margin-left-3 margin-bottom-0px label-table-color"> {{l.ActivityDate| date:'MMM-dd-yyyy'}}</label>
      </div>-->
                      <div *ngSwitchCase="'Scheduled'" class="td-border-8px-green">
                        <label class="margin-left-3 margin-bottom-0px label-table-color"> {{l.ActivityDate| date:'MMM-dd-yyyy'}}</label>
                      </div>
                      <div *ngSwitchCase="'Rescheduled'" class="td-brorder-8px-blue">
                        <label class="margin-left-3 margin-bottom-0px label-table-color"> {{l.ActivityDate| date:'MMM-dd-yyyy'}}</label>
                      </div>
                      <div *ngSwitchCase="'Discussed'" class="td-brorder-8px-blue">
                        <label class="margin-left-3 margin-bottom-0px label-table-color"> {{l.ActivityDate| date:'MMM-dd-yyyy'}}</label>
                      </div>

                      <div *ngSwitchCase="'Cancelled'" class="td-border-8px-red">
                        <label class="margin-left-3 margin-bottom-0px label-table-color margin-bottom-0px"> {{l.ActivityDate| date:'MMM-dd-yyyy'}}</label>
                      </div>
                      <div *ngSwitchCase="'No Answer'" class="td-border-8px-red">
                        <label class="margin-left-3 margin-bottom-0px label-table-color margin-bottom-0px"> {{l.ActivityDate| date:'MMM-dd-yyyy'}}</label>
                      </div>
                      <div *ngSwitchCase="'Not Reachable'" class="td-border-8px-red">
                        <label class="margin-left-3 margin-bottom-0px label-table-color margin-bottom-0px"> {{l.ActivityDate| date:'MMM-dd-yyyy'}}</label>
                      </div>
                      <div *ngSwitchCase="'Completed'" class="td-border-8px-green">
                        <label class="margin-left-3 margin-bottom-0px label-table-color margin-bottom-0px"> {{l.ActivityDate| date:'MMM-dd-yyyy'}}</label>
                      </div>
                      <div *ngSwitchCase="'Overdue'" class="td-border-8px-Black">
                        <label class="margin-left-3 margin-bottom-0px label-table-color margin-bottom-0px"> {{l.ActivityDate| date:'MMM-dd-yyyy'}}</label>
                      </div>
                      <div *ngSwitchCase=" " class="">
                        <label class="margin-left-3 margin-bottom-0px label-table-color  margin-bottom-0px"> {{l.ActivityDate| date:'MMM-dd-yyyy'}}</label>
                      </div>
                    </div>


                  </td>

                  <td class="td-padding-tb">
                    {{l.DisplayName}}
                  </td>
                  <td>{{l.FacilityShortName}}</td>
                  <td class="text-align-center td-padding-tb">
                    <div [ngSwitch]="l.FollowupMode">
                      <div *ngSwitchCase="'Email'" class="">
                        <i class="fa fa-envelope "></i>
                      </div>
                      <div *ngSwitchCase="'Phone'" class="">
                        <i class="fas fa-mobile-alt"></i>
                      </div>
                      <div *ngSwitchCase="'Visit'" class="">
                        <i class="fa fa-handshake"></i>
                      </div>
                      <div *ngSwitchCase="'Other'" class="">
                        <label>{{l.FollowupMode}}</label>
                      </div>
                    </div>

                  </td>
                  <td class="td-padding-tb">
                    <div [ngSwitch]="l.FollowupStatus">
                      <div *ngSwitchCase="'Scheduled'" class="">
                        <i class="fa fa-check color-green"></i>
                        {{l.FollowupStatus}}
                      </div>
                      <div *ngSwitchCase="'Completed'" class="">
                        <i class="fa fa-check color-green"></i>
                        {{l.FollowupStatus}}
                      </div>
                      <div *ngSwitchCase="'ReScheduled'" class="">
                        <label>{{l.FollowupStatus}}</label>
                      </div>
                      <div *ngSwitchCase="'Overdue'" class="">
                        <label>{{l.FollowupStatus}}</label>
                      </div>
                      <div *ngSwitchCase="'Not Reachable'" class="">
                        <label>{{l.FollowupStatus}}</label>
                      </div>
                      <div *ngSwitchCase="'Not Answer'" class="">
                        <label>{{l.FollowupStatus}}</label>
                      </div>
                      <div *ngSwitchCase="'Discussed'" class="">
                        <label>{{l.FollowupStatus}}</label>
                      </div>
                      <div *ngSwitchCase="'Cancelled'" class="">
                        <label>{{l.FollowupStatus}}</label>
                      </div>
                    </div>
                    <!--{{l.FollowupStatus}}-->
                  </td>
                  <td>{{l.CreatedUser}}</td>
                  <td>{{l.AssignedToName}}</td>
                  <td class="td-padding-tb td-elipsis">{{l.Remarks}}</td>

                  <td class="td-padding-tb">
                    <!--<a (click)="del_(l.EducationCode)" class="nav-link-hand education-navlink" title="Remove">
    <span class="badge">
      <i class="far fa-trash-alt"></i>
    </span>
  </a>-->
                    <a class="nav-link-hand education-navlink" title="To Activies" (click)="Open(l)">
                      <span class="badge">
                        <i class="fas fa-external-link-alt"></i>
                      </span>
                    </a>
                    <a class="nav-link-hand education-navlink" title="Edit" (click)="edit(l)">
                      <span class="badge"><i class="fas fa-pencil-alt"></i></span>
                    </a>
                    <a (click)="DeleteActivity(l)"                       
                       class="nav-link-hand font-size-14 color-Rejected" title="Remove">
                      <i class="far fa-trash-alt nav-link-hand"></i>
                    </a>
                    <!--<div *ngIf="">
    <button type="button" (click)="opendocuments()"
            class="btn  actions-btn-prime2 benfits-button font-size min-width-42px float-left margin-left-0px">
      <i class="fas fa-list"></i>
    </button>
  </div>-->
                    <div>
                      <!--<button type="button" (click)="AddPlan()"
            class="btn  btn-sm driver-button " title="Add">
      <i class="fas fa-plus font-size-11"></i>
    </button>-->
                    </div>
                  </td>

                </tr>

              </tbody>

            </table>
          </div>
        </div>
      </div>
    </div>
   
  </div>
</div>

<activitymonitoring [FormattedCode]='Selectedpatient.FormattedCode' [ActorCode]='Selectedpatient.ActorCode'  *ngIf="ShowMonitoring" ></activitymonitoring>
<router-outlet></router-outlet>
